import React, { useRef, useState } from 'react';
import Accordion from '../../atoms/Accordion';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './EnergiaSolarFaq.css';
import { Faqs } from './EnergiaSolarFaqPerguntas';

function EnergiaSolarFaq() {
  const accRefs = useRef(Faqs.map(() => React.createRef()));

  const handleAccChange = (index, open) => {
    if (!open) return;
    accRefs.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <section id="perguntas">
      <ContainerHome24>
        <div className="perguntas-contain">
          <div className="group-perguntas">
            {Faqs.map((faq, index) => (
              <Accordion
                key={index}
                title={faq.pergunta}
                accordionRef={accRefs.current[index]}
                onChange={(open) => handleAccChange(index, open)}
                startOpen={faq.startOpen}
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: faq.resposta,
                  }}
                />
              </Accordion>
            ))}
          </div>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default EnergiaSolarFaq;
